module.exports = __webpack_public_path__ + "static/media/portis.871719fb.svg";